<template><BusinessPage module-key="classes" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'ClassesPage', components: { BusinessPage } }</script>
